import React from 'react';

import { Modal } from 'src/components/common';
import { GetWorkLetterForm } from 'src/components/position';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

export type GetWorkLetterModalProps = {
  employeeSsnEncrypted?: string;
  onGenerated?: () => void;
};

export const GetWorkLetterModal: React.FC<ModalV2Props<GetWorkLetterModalProps>> = ({
  id,
  employeeSsnEncrypted,
  onGenerated,
}) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Get Work Letter"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
      headerPadding="32px 32px 8px 32px"
      maxWidth={550}
    >
      <GetWorkLetterForm
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        employeeSsnEncrypted={employeeSsnEncrypted}
        onGenerated={onGenerated}
      />
    </Modal>
  );
};
